const getConfig = () => window.envConfig;
const getClientVersion = () => window.clientVersion;

export {
  getConfig,
  getClientVersion
};
